import styled from "styled-components";
interface Props{
  loading: boolean;
}
export const Content = styled.button<Props>`
  min-width: 175px;
  height: 45px;
  background-color: ${({ theme, loading }) => loading ? 'rgba(0, 191, 165, 0.5)' : theme.colors.primary};
  color: ${({ theme }) => theme.colors.secondary10};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 500;
  border-radius: 8px;
  padding: 5px;
  cursor: pointer;
  .loading {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .ant-spin-dot-item {
      background-color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
